<div *ngIf="appUpdate" class="new-version-available">
  Nouvelle version de l'application disponible.

  <button mat-raised-button (click)="reloadApp()">
    <mat-icon>refresh</mat-icon>
    Recharger
  </button>
</div>
